import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const SideMenu = ({ menu }) => {
    const location = useLocation();
    const pathName = location.pathname.split('-')[0];

    // Khởi tạo state từ localStorage nếu có dữ liệu, nếu không thì mặc định là {}
    const [openSubMenus, setOpenSubMenus] = useState(() => {
        const saved = localStorage.getItem('openSubMenus');
        return saved ? JSON.parse(saved) : {};
    });

    // Hàm mở/đóng submenu và lưu trạng thái vào localStorage
    // const toggleSubMenu = (index) => {
    //     setOpenSubMenus((prev) => {
    //         const updated = {
    //             [index]: !prev[index],
    //         };
    //         localStorage.setItem('openSubMenus', JSON.stringify(updated));
    //         return updated;
    //     });
    // };

    // Tự động mở submenu dựa trên URL hiện tại
    useEffect(() => {
        menu.forEach((item, index) => {
            if (item.subMenu) {
                const isActive = item.subMenu.some((subItem) => subItem.url === pathName);
                if (isActive) {
                    setOpenSubMenus(() => {
                        const updated = {
                            [index]: true,
                        };
                        localStorage.setItem('openSubMenus', JSON.stringify(updated));
                        return updated;
                    });
                }
            }
        });
    }, [pathName, menu]);

    return (
        <div className="profile-sidebar">
            <ul>
                {menu.map((item, index) => (
                    <li key={index}>
                        {item.title ? (
                            <>
                                <h1
                                    className={`${openSubMenus[index] ? 'active' : ''} ${
                                        item.subMenu && item.subMenu.length > 0 ? 'has-submenu' : ''
                                    } `}
                                >
                                    <span dangerouslySetInnerHTML={{ __html: item.context.replace(/\n/g, '<br/>') }} />
                                    {/* <i className={`icon icon-right-active ${openSubMenus[index] ? 'active' : ''}`}></i> */}
                                </h1>
                                {/* {openSubMenus[index] && item.subMenu && item.subMenu.length > 0 && ( */}
                                {item.subMenu && item.subMenu.length > 0 && (
                                    <ul className="submenu">
                                        {item.subMenu.map((subItem, subIndex) => (
                                            <li key={subIndex}>
                                                {subItem.navigator ? (
                                                    <a
                                                        href={subItem.url}
                                                        className={
                                                            pathName === subItem?.url ||
                                                            (Array.isArray(subItem?.internalUrl)
                                                                ? subItem.internalUrl.includes(pathName)
                                                                : subItem?.internalUrl === pathName)
                                                                ? 'activeNosub active'
                                                                : ''
                                                        }
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: subItem.context.replace(/\n/g, '<br/>'),
                                                            }}
                                                        />
                                                    </a>
                                                ) : (
                                                    <NavLink
                                                        to={subItem.url}
                                                        className={
                                                            pathName === subItem?.url ||
                                                            (Array.isArray(subItem?.internalUrl)
                                                                ? subItem.internalUrl.includes(pathName)
                                                                : subItem?.internalUrl === pathName)
                                                                ? 'activeNosub active'
                                                                : ''
                                                        }
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: subItem.context.replace(/\n/g, '<br/>'),
                                                            }}
                                                        />
                                                    </NavLink>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        ) : item.navigator ? (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                                className={pathName === item.url ? 'activeNosub' : ''}
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open(item.url, '_blank');
                                }}
                            >
                                <span dangerouslySetInnerHTML={{ __html: item.context.replace(/\n/g, '<br/>') }} />
                            </a>
                        ) : (
                            <NavLink
                                to={item.url}
                                className={`${pathName === item.url ? 'activeNosub' : ''}
                                ${
                                    pathName === item?.url ||
                                    (Array.isArray(item?.internalUrl)
                                        ? item.internalUrl.includes(pathName)
                                        : item?.internalUrl === pathName)
                                        ? 'activeNosub active'
                                        : ''
                                }`}
                            >
                                <span dangerouslySetInnerHTML={{ __html: item.context.replace(/\n/g, '<br/>') }} />
                            </NavLink>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SideMenu;
